import { c as _c } from "react/compiler-runtime";
import { Dialog, Stack } from '@mui/material';
import classnames from 'classnames';
import React, { type PropsWithChildren } from 'react';
import { Loader } from '@/components/shared/loader';
import { PanelWrapper, type PanelWrapperProps } from '../panels/panelWrapper';
export interface MainDialogProps extends PanelWrapperProps {
  isOpen: boolean;
  isLoading: boolean;
  disableGutters?: boolean;
  /** Render as a full-viewport overlay instead of a centered modal. */
  fullScreen?: boolean;
}
export function MainDialog(props) {
  const $ = _c(30);
  const {
    isLoading,
    isOpen,
    header,
    footer,
    sx,
    disableGutters: t0,
    fullScreen: t1
  } = props;
  const disableGutters = t0 === undefined ? false : t0;
  const fullScreen = t1 === undefined ? false : t1;
  let t2;
  if ($[0] !== header) {
    t2 = () => {
      header?.onClose?.();
    };
    $[0] = header;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== fullScreen || $[3] !== sx) {
    t3 = {
      paper: {
        sx: fullScreen ? {
          width: "100%",
          height: "100%",
          maxWidth: "100%",
          maxHeight: "100%",
          borderRadius: "0px",
          ...sx
        } : {
          width: "40%",
          maxWidth: "840px",
          minWidth: "600px",
          height: "max-content",
          minHeight: "300px",
          maxHeight: "90vh",
          borderRadius: "16px",
          ...sx
        }
      }
    };
    $[2] = fullScreen;
    $[3] = sx;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== header) {
    t4 = header ? {
      ...header
    } : undefined;
    $[5] = header;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== footer) {
    t5 = footer ? {
      ...footer
    } : undefined;
    $[7] = footer;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  const t6 = !disableGutters;
  let t7;
  if ($[9] !== t6) {
    t7 = classnames("h-full", {
      "py-[24px]": t6
    });
    $[9] = t6;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  let t8;
  if ($[11] !== isLoading) {
    t8 = isLoading && <Loader />;
    $[11] = isLoading;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  let t9;
  if ($[13] !== isLoading || $[14] !== props.children) {
    t9 = !isLoading && <>{props.children}</>;
    $[13] = isLoading;
    $[14] = props.children;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  let t10;
  if ($[16] !== t7 || $[17] !== t8 || $[18] !== t9) {
    t10 = <Stack className={t7}>{t8}{t9}</Stack>;
    $[16] = t7;
    $[17] = t8;
    $[18] = t9;
    $[19] = t10;
  } else {
    t10 = $[19];
  }
  let t11;
  if ($[20] !== t10 || $[21] !== t4 || $[22] !== t5) {
    t11 = <PanelWrapper rounded={true} header={t4} footer={t5}>{t10}</PanelWrapper>;
    $[20] = t10;
    $[21] = t4;
    $[22] = t5;
    $[23] = t11;
  } else {
    t11 = $[23];
  }
  let t12;
  if ($[24] !== fullScreen || $[25] !== isOpen || $[26] !== t11 || $[27] !== t2 || $[28] !== t3) {
    t12 = <Dialog fullScreen={fullScreen} onClose={t2} onClick={_temp} open={isOpen} slotProps={t3}>{t11}</Dialog>;
    $[24] = fullScreen;
    $[25] = isOpen;
    $[26] = t11;
    $[27] = t2;
    $[28] = t3;
    $[29] = t12;
  } else {
    t12 = $[29];
  }
  return t12;
}
function _temp(event) {
  return event.stopPropagation();
}